@import '../../theme/global.scss';

:host {
  @include set-font;
  display: flex;
  flex-flow: column;
  padding-top: 8px;
  width: 100%;

  snap-card-section {
    padding-top: 16px;
  }

  snap-card-section:first-child {
    padding-top: 0;
  }
  @media (min-width: 768px) {
    align-items: center;
    flex: 1 1 75%;
    flex-flow: row;
    justify-content: space-between;

    snap-card-section {
      padding-top: 0;
    }
  }
}
